import { useMemo } from "react";
import { IGif, INicheMap, IUser } from "@/common/services/types";
import { useGifStore } from "@/common/store/gifStore";
import { useUsersStore } from "@/common/store/storeUsers";
import { useNichesStore } from "@/common/store/storeNiches";

interface IUseStoreGifData {
  fallbackGif: IGif;
  fallbackUser?: IUser;
  fallbackNiches?: INicheMap;
}

export const useStoreGifData = ({ fallbackGif, fallbackNiches, fallbackUser }: IUseStoreGifData) => {
  const storeGifs = useGifStore(state => state.gifs);
  const storeUsers = useUsersStore(state => state.users);
  const storeNiches = useNichesStore(state => state.niches);

  const getGifById = useGifStore(state => state.getGifById);
  const getUser = useUsersStore(state => state.getUser);
  const getNiches = useNichesStore(state => state.getNiches);

  const gif = useMemo(() => getGifById(fallbackGif.id) || fallbackGif, [storeGifs]);
  const user = useMemo(() => getUser(fallbackGif.userName) || fallbackUser, [storeUsers]);
  const niches = useMemo(() => getNiches(fallbackGif.niches) || fallbackNiches, [storeNiches]);

  return {
    gif,
    user,
    niches
  };
};
